// extracted by mini-css-extract-plugin
export default {"card":"PropostaIndicadorForm_card__FOgHB","buttonStatus":"PropostaIndicadorForm_buttonStatus__Js9os","header":"PropostaIndicadorForm_header__avTMI"};